// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__CzS24","colMin":"styles_colMin__1IFtj","colCheckbox":"styles_colCheckbox__QQdbc"};